<template>
	<div class="entry customer-item" :class="{}"
	     @click="customerOpen=true">
		<div class="cell time">
			<span class="cell-value">{{ date }}</span>
		</div>

		<div class="cell customer-name">
			<div v-if="customer.first_name || customer.last_name" class="cell-title">
				{{ customer.first_name }} {{ customer.last_name }}
			</div>
		</div>
		<div class="cell customer">
			<div v-if="customer.optin_email" class="cell-value layout-row flex-center">
				<span>
				{{ customer.optin_email }}
				</span>
				<span class="tag" v-if="customer.is_auto_optin">Auto-optin</span>
			</div>
			<div v-else class="cell-value">
				Unknown customer
			</div>
		</div>
		<div class="cell orders">
			{{customer.purchases||'0'}} order{{customer.purchases===1?'':'s'}}
		</div>
		<div class="cell ltv">
			{{currency('USD')}} {{customer.ltv||'0'}}
		</div>
		<div class="cell actions">
			<quick-actions-btn :items="[
		            		{label:'Edit'},'',
		            		{label:'Delete customer',icon:require('@/assets/img/cross.svg')}]"
			                   @menuClick="menuClick" :loading="orderMenuLoading" />
		</div>

		<portal to="popup">
			<popup-backdrop v-if="customerOpen" @close="customerOpen=false">
				<customer-details-new v-if="customerOpen" @close="customerOpen=false"
				                      @done="customerOpen=false"
				                      :customer-id="customer.id" :level="0" />
			</popup-backdrop>

			<customer-delete-popup v-if="deleteCustomerPopup" :customer="customer"
			                       @done="$emit('deleted', customer)"
			                       @close="deleteCustomerPopup=false" />

		</portal>

	</div>
</template>

<script>
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import {getSymbol} from "@/helpers/currencies";
import API from '@/api';
import CustomerDetailsNew from "@/views/customers/customer-details-new";
import numbers from '@/helpers/numbers'
import IntermediatePanel from "@/views/orders/intermediate-panel";
import PopupBackdrop from "@/components/base/popup-backdrop";
import CustomerDeletePopup from "@/components/popups/delete/CustomerDeletePopup";
const moment = require('moment-timezone');

export default {
	name: "customer-item", components: {
		CustomerDeletePopup,
		PopupBackdrop,
		IntermediatePanel,
		CustomerDetailsNew,
		QuickActionsBtn},
	props: ['customer'],
	mixins:[API],
	data(){
		return {
			deleteCustomerPopup: false,
			orderMenuLoading: false,
			customerOpen: false,
		}
	},
	computed:{
		date() {
			let d = this.customer.time;

			let dd = moment(d);
			if (dd.isSame(moment(), 'day'))
				return 'Today, '+dd.format("HH:mm")
			if (dd.isSame(moment(), 'year'))
				return dd.format("DD MMM, HH:mm")
			return dd.format("DD MMM YYYY, HH:mm")
		},
	},
	methods:{
		round(n){
			return numbers.round_to_two(n)
		},
		menuClick(e){
			if (e.action==='Edit') {
				this.customerOpen = true;
			} else if (e.action==='Delete customer') {
				this.deleteCustomerPopup = true;
			}
		},
		currency(c) {
			return getSymbol(c);
		},
	}
}
</script>

<style lang="scss" scoped>
.customer-item {
	border-radius: 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	line-height: 1.5;
	padding: 0 20px;
	opacity: 0;
	animation: appear 1 0.3s forwards;
	background: transparent;

	.tag {
		display: flex;
		background: whitesmoke;
		border-radius: 4px;
		padding: 4px 8px;
		line-height: normal;
		color: $dark-grey;
		margin-left: 6px;
		font-size: 10px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	&:hover {
		background: $light-silver;
	}
	&.canceled {
		.cell-title, .cell-value, .amount, .name {
			text-decoration: line-through;
		}
	}
	&.archived {
		.cell-title, .cell-value, .status, .amount, .name {
			color: $dark-grey;
		}
	}
}
</style>
